import { ApiResponse, HTTPVerb } from '../Modules/Utils/API/Interfaces/IApi';
import { ApiManager } from '../Modules/Utils/API/ApiManager';

enum APIConstants {
    GetWaitingMessages = '/api/OMG/GetWaitingMessages/',
}

export interface IGetWaitingMessagesRequest {
    ProductPackage: string;
}

export interface IGetWaitingMessagesResponse {
    MessagesDetails?: string;
    ErrorCode?: number;
    ErrorDescription?: string;
    IsOk: boolean;
}

export default class OMGApi {
    public static GetWaitingMessages = (
        data: IGetWaitingMessagesRequest,
    ): Promise<ApiResponse<IGetWaitingMessagesResponse>> => {
        return ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.GetWaitingMessages,
            method: HTTPVerb.POST,
            data,
        });
    };
}
